import request from '@/utils/request2'

// 获取微信小店类目接口
export function getWechartCategory(params) {
  return request({
    url: `/cloud/edata-commodity/admin/wechat/category/list`,
    method: 'GET',
    params
  })
}

// 根据机构ID查询商品类目配置（查不到回落默认tenantId=0）
export function getGoodsProductCategoryConfig(params) {
  return request({
    url: `/cloud/admin/goods/productCategory/config`,
    method: 'GET',
    params
  })
}

// 获取类目的历史记录选择
export function getCategorySelect(params) {
  return request({
    url: `/cloud/edata-commodity/admin/wechat/category/getCategorySelect`,
    method: 'GET',
    params
  })
}

// 保存类目的历史记录选择
export function saveCategorySelect(params) {
  return request({
    url: `/cloud/edata-commodity/admin/wechat/category/saveCategorySelect`,
    method: 'post',
    data: params
  })
}
